import { getHalDisplay } from '../../utils/terminologyMap'

interface Props {
  hal?: string
}

const HAL_COLORS: Record<string, string> = {
  tevbe: '#9CA3AF', zuhd: '#6B7280', sabir: '#3B82F6',
  sukur: '#10B981', riza: '#8B5CF6', tevekkul: '#F59E0B', muhabbet: '#EC4899',
}

export default function HalIndicator({ hal = 'tevbe' }: Props) {
  const label = getHalDisplay(hal)
  const color = HAL_COLORS[hal] || '#9CA3AF'

  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', gap: 4,
      padding: '3px 8px', borderRadius: 4, fontSize: 10, fontWeight: 500,
      color, background: `${color}15`, border: `1px solid ${color}25`,
    }}>
      ✦ {label}
    </span>
  )
}
